import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { Spacer, Flexer, Button } from '@ontruck/orc';

import { getShipperOrderDetailData } from 'redux/modules/shipper-order-detail/selectors';

import { editOrder, repeatOrder } from 'redux/modules/shipper-order-detail/effects';

import { HeaderStyled, FlexerParentMaxHeightStyled } from 'modules/detail/styled';
import { IS_TENANT } from 'tenant/config';

import {
  IdCell,
  LoadSummaryCell,
  WeightCell,
  HeightCell,
  ExtrasSummary,
  Documents,
} from 'modules/Common/Details';

const t = {
  edit: 'Edit order',
  repeat: 'Repeat order',
  reviewed: 'Reviewed',
  go_back: 'Go to Queued',
  frozen: 'FROZEN',
};

const Header = ({ shipperOrder, repeatOrder, editOrder }) => {
  const { pathname } = useLocation();
  const { is_frozen: isFrozen, id, recurring_order } = shipperOrder || {};
  return (
    <HeaderStyled alignItems="center">
      <FlexerParentMaxHeightStyled alignItems="center">
        {!!shipperOrder && (
          <>
            <Spacer mRight="M" mLeft="M">
              <IdCell
                id={id}
                idType={'shipperorder'}
                copiable
                isRecurring={!!recurring_order}
                color="white"
              />
            </Spacer>
            {/* hide weight and pallets count for tenant (they use containers) */}
            {!IS_TENANT && (
              <>
                <Spacer mRight="M">
                  <LoadSummaryCell {...shipperOrder} showEquivalents />
                </Spacer>
                <Spacer mRight="M">
                  <WeightCell {...shipperOrder} />
                </Spacer>
                <Spacer mRight="M">
                  <HeightCell {...shipperOrder} color="white" />
                </Spacer>
                <Spacer mRight="M">
                  <ExtrasSummary
                    {...shipperOrder}
                    config={{
                      additionalDocuments: {
                        show: false,
                      },
                    }}
                    s
                    small
                    color="white"
                  />
                </Spacer>
              </>
            )}
            <Spacer>
              <Documents {...shipperOrder} color="white" />
            </Spacer>
          </>
        )}
      </FlexerParentMaxHeightStyled>
      {!!shipperOrder && (
        <>
          <Flexer.Child>
            <Flexer.Parent mRight="S">
              <Flexer.Child>
                <Button nude text={t.repeat} onClick={() => repeatOrder(id)} skin="light" />
              </Flexer.Child>
              <Flexer.Child>
                {!isFrozen && !IS_TENANT && (
                  <Button
                    ghost
                    text={t.edit}
                    onClick={() => editOrder(id, pathname)}
                    skin="light"
                  />
                )}
              </Flexer.Child>
            </Flexer.Parent>
          </Flexer.Child>
        </>
      )}
    </HeaderStyled>
  );
};

Header.propTypes = {
  primary900: PropTypes.object,
  editOrder: PropTypes.func,
  repeatOrder: PropTypes.func,
};

Header.defaultProps = {
  shipperOrder: {},
};

export default connect(
  (state) => {
    return {
      shipperOrder: getShipperOrderDetailData(state),
    };
  },
  {
    editOrder,
    repeatOrder,
  }
)(Header);
